import React, { FC, useCallback } from "react";
import { useDispatch } from "react-redux";
import { noop } from "lodash";
import { setDialog } from "store/Shared";
import SubmitButton, { Themes } from "component/SubmitButton";

export const SignupButton: FC<{
  className?: string;
  theme?: keyof typeof Themes;
  onClick?: () => void;
}> = ({ className, theme = "white", onClick = noop }) => {
  const dispatch = useDispatch();
  const showSignup = useCallback(() => {
    dispatch(setDialog("signup"));
    onClick();
  }, [onClick]);
  return (
    <SubmitButton
      onClick={showSignup}
      theme={theme}
      className={`signup-button ${className}`}
    >
      Sign Up
    </SubmitButton>
  );
};

export default SignupButton;
